// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".trbo-a-question-renderer[data-v-2579ba7c] {\n    flex-grow: 1\n}", "",{"version":3,"sources":["<no source>","webpack://./wizard-page.scss"],"names":[],"mappings":"AAAA;IAAA;ACEA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
